import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_PROGRAMA_CEAO_MEDICO = gql`
  mutation saveVisitaCeaoMedico($input: AddVisitaCeaoMedicoInput!) {
    saveVisitaCeaoMedico(input: $input) {
      idVisita
      idVisitaCeao
    }
  }
`;

export default SAVE_PROGRAMA_CEAO_MEDICO;

export const adaptAddVisitaCEAOMedicoInput = (data) => ({
  idVisitaCeao: data?.idVisitaCeao,
  justificacionModificacion: data?.justificacionModificacion,
  indicacionComentario: data?.indicacionComentario,
  suplementoVitaminico: !!data?.suplementoVitaminico,
  suplemento: data?.suplemento,
  indicacionSuplemento: data?.indicacionSuplemento,
  caloriasTotales: data?.caloriasTotales,
  caloriasSO: data?.caloriasSO,
  porcentajeSO: data?.porcentajeSO,
  cantidadAnticonvulsivante: data?.cantidadAnticonvulsivante,
  medicacionAnticonvulsivante: data?.medicacionAnticonvulsivante,
  cetonemia: !!data?.cetonemia,
  resultadoCetonemia: data?.resultadoCetonemia,
  cetonuria: !!data?.cetonuria,
  resultadoCetonuria: data?.resultadoCetonuria,
  cantidadCrisis: data?.cantidadCrisis,
  observacion: data?.observacion,
  complicaciones: data?.complicaciones,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  idVisita: data?.idVisita
});